import React, { Children } from 'react';
import PropTypes from 'prop-types';
import Markdown from '../Richtext/Markdown';

// ====

const CardReview = (props) => {
  const { copy, reviewer, rating } = props;

  // ====

  return (
    <li className="list-inline-item">
      <div className="card h-100 brand-background-grey-lighter">
        <div className="card-body">{copy && <Markdown>{copy}</Markdown>}</div>
        <div className="card-footer border-0 brand-background-transparent">
          {reviewer && <p className="m-0 small">{reviewer}</p>}
          {rating && <p className="m-0 brand-text-red">{rating}</p>}
        </div>
      </div>
    </li>
  );
};

export default CardReview;

// ====

CardReview.propTypes = {
  reviewer: PropTypes.string,
  copy: PropTypes.string,
  rating: PropTypes.string,
};

CardReview.defaultProps = {
  reviewer: null,
  copy: null,
  rating: null,
};
